import { apiClient } from "./api-client"
import type { ReportDeliveryTypeResponse } from "@/types/delivery"

const BASE_PATH = "/ReportingInterface"

export const deliveryApi = {
  async getReportDeliveryTypes(): Promise<ReportDeliveryTypeResponse[]> {
    return apiClient.get(`${BASE_PATH}/GetReportDeliveryTypes`)
  },
}
